import { message, Modal, Input, Form } from 'antd';
import { MODAL_NAME } from 'constants/modal';
import API from 'api';
import TextField from 'views/common/TextField';
import { useState } from 'react';
import { useValidate, ValidateContext } from 'views/context/ValidateContext';
import FieldRegister from 'views/common/FieldRegister';

import {
  validateNewPassEqualConfirmPass,
  validatePassword,
} from 'utils/validate';
import { CheckOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from 'store/reducers/modal';

const validateRequired = (field) => (v) => {
  if (!v) {
    return field + 'is required';
  }
};

const PopupChangePassword = (props) => {
  const { open } =
    useSelector((state) => state.modal[MODAL_NAME.CHANGE_PASSWORD]) || {};
  const [state, setState] = useState({});
  const validate = useValidate('change-pass');
  const dispatch = useDispatch();

  const onChangeField = (e, field) => {
    setState((s) => ({ ...s, [field]: e.target.value }));
  };

  const onCancel = () => {
    setState({});
    dispatch(closeModal({ name: MODAL_NAME.CHANGE_PASSWORD }));
  };

  const onClickSave = async () => {
    const errors = validate.validateFields();

    if (Object.values(errors || {}).length > 0) {
      return;
    }

    const body = {
      oldPass: state.oldPass,
      newPass: state.newPass,
    };
    const res = await API.changePass(body);
    if (res.status === 200) {
      message.success('Change password successed!');
      return onCancel();
    }
    message.error(res.message);
  };

  const onKeydown = (e) => {
    if (e.code === 'Enter' || e.code === 'NumpadEnter') {
      onClickSave();
    }
  };

  return (
    <Modal
      className="change_password"
      title="Change password"
      open={open}
      okText="Save"
      okType="outlined"
      onCancel={onCancel}
      onOk={onClickSave}
      width="700px"
      okButtonProps={{
        type: 'primary',
        icon: <CheckOutlined />,
      }}
    >
      <Form name="change-password">
        <ValidateContext.Provider value={validate}>
          <div className="pb-3">
            <FieldRegister
              name="oldPassword"
              value={state.oldPass}
              validate={[validateRequired('Old Password')]}
              onChange={(e) => onChangeField(e, 'oldPass')}
              onKeydown={onKeydown}
            >
              {({ value, onChange, onBlur, error, onKeydown }) => (
                <TextField label="Old Password" helperText={error} required>
                  <Input.Password
                    size="medium"
                    placeholder="Enter Old Password"
                    onChange={onChange}
                    value={value}
                    onKeyDown={onKeydown}
                    autoComplete="section-change oldpass"
                    id="old-password"
                    onBlur={onBlur}
                  />
                </TextField>
              )}
            </FieldRegister>
          </div>

          <div className="pb-3">
            <FieldRegister
              name="newPassword"
              value={state.newPass}
              validate={[
                validateRequired('New Password'),
                validatePassword,
                validateNewPassEqualConfirmPass,
              ]}
              onChange={(e) => onChangeField(e, 'newPass')}
              depend={state.confirmPass}
              onKeyDown={onKeydown}
            >
              {({ value, onChange, onBlur, error, onKeydown }) => (
                <TextField label="New Password" helperText={error} required>
                  <Input.Password
                    size="medium"
                    placeholder="Enter New Password"
                    onChange={onChange}
                    value={value}
                    onKeyDown={onKeydown}
                    onBlur={onBlur}
                    id="new-password"
                    autoComplete="section-change newpass"
                  />
                </TextField>
              )}
            </FieldRegister>
          </div>

          <div className="pb-3">
            <FieldRegister
              name="confirmPassword"
              value={state.confirmPass}
              validate={[
                validateRequired('Confirm Password'),
                validateNewPassEqualConfirmPass,
              ]}
              depend={state.newPass}
              onChange={(e) => onChangeField(e, 'confirmPass')}
              onKeyDown={onKeydown}
            >
              {({ value, onChange, onBlur, error, onKeydown }) => (
                <TextField label="Confirm Password" helperText={error} required>
                  <Input.Password
                    size="medium"
                    placeholder="Confirm Your New Password"
                    onChange={onChange}
                    value={value}
                    onKeyDown={onKeydown}
                    onBlur={onBlur}
                    autoComplete="section-change confirmpass"
                    id="confirm-password"
                  />
                </TextField>
              )}
            </FieldRegister>
          </div>
        </ValidateContext.Provider>
      </Form>
    </Modal>
  );
};

export default PopupChangePassword;
